import type { DashboardAtlas } from "@/components/ecv2/components/whiteboardEC/runtime/dashboardAtlas";
import { createContext, useContext } from "react";

export const AtlasContext = createContext<DashboardAtlas | null>(null);

export function useAtlasOrNull(): DashboardAtlas | null {
  return useContext(AtlasContext);
}

export function useAtlas(): DashboardAtlas {
  const atlas = useAtlasOrNull();
  if (!atlas) {
    throw new Error("Atlas context is missing.");
  }
  return atlas;
}
